export const addLocaleToBasketUrl = (path: string, locale: string): string => {
  const delimiter = path.indexOf('?') > -1 ? '&' : '?';
  return `${path}${delimiter}locale=${locale}`;
};
